module.exports = __webpack_public_path__ + "img/yoututor.9227f474.jpg";